import {
  TextMedium,
  TextRegular,
  Title,
} from "../../styles/GlobalStyledComponents";
import {
  ButtonCheckbox,
  ButtonText,
  CheckboxContainer,
  ShippingButton,
  ShippingOptions,
  TextRegularEllipsis,
} from "./OperationShippingFormStyledComponents";
import { MainButton } from "../../styles/GlobalStyledComponents";
import { CustomerContext } from "../../contexts/CustomerContext/customer-context";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES_PATH } from "../../constants";
import { NotificationType } from "../../interfaces/NotificationType";
import { useCreditProposalResult } from "../../contexts/CreditProposalResultContext";
import { CreditProposalFlowStep } from "../../interfaces/CreditProposalResult";
import CreditProposalService from "../../services/CreditProposal";
import AnalyticsService from "../../services/Analytics";
import AnalyticsHelper from "../../utils/analyticsHelper";
import dayjs from "dayjs";
import { useCustomer } from "../../contexts/CustomerContext";
import { useMerchant } from "../../contexts/MerchantContext";

interface OperationShippingProps {
  showContinueBtn: boolean;
  loadingRequest: (data: boolean) => void;
  operationMethod: (data: NotificationType) => void;
}

export const OperationShippingForm: React.FC<OperationShippingProps> = ({
  showContinueBtn,
  loadingRequest,
  operationMethod,
}) => {
  const navigate = useNavigate();
  const { customer } = useCustomer();
  const { creditProposalResult } = useCreditProposalResult();
  const { isNemuru } = useMerchant();
  const [optionSelected, setOptionSelected] = useState<NotificationType | null>(
    null
  );

  const startTime = dayjs();

  const verifyApiCall = async (counter: number, isVerify: boolean) => {
    const count = counter;
    try {
      if (isVerify) {
        !isNemuru &&
          (await CreditProposalService.verifyBankreader(
            creditProposalResult!.credit_proposal_id
          ));
        AnalyticsService.verify();
        loadingRequest(false);
        navigate(ROUTES_PATH.END);
      } else {
        !isNemuru &&
          (await CreditProposalService.activateCreditProposal(
            creditProposalResult!.credit_proposal_id
          ));
        loadingRequest(false);
        navigate(ROUTES_PATH.END);
      }
    } catch (error: any) {
      const errorCode = error.response?.data.result.errors[0]?.code;
      if (
        error.result.http_code === 422 &&
        errorCode === "DRF0027" &&
        count < 3
      ) {
        setTimeout(() => {
          verifyApiCall(count + 1, isVerify);
        }, 3000);
      } else {
        loadingRequest(false);
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
      }
    }
  };

  const continueNavigation = () => {
    switch (creditProposalResult?.flow_step) {
      case CreditProposalFlowStep.PAYMENT:
        navigate(ROUTES_PATH.PAYMENT);
        break;
      case CreditProposalFlowStep.OCR:
        navigate(ROUTES_PATH.OCR);
        break;
      case CreditProposalFlowStep.ESIGNATURE:
        // case "DECISION_PAC":
        navigate(ROUTES_PATH.SIGNATURE);
        break;
      case CreditProposalFlowStep.ACTIVATION:
        verifyApiCall(0, false);
        break;
      case CreditProposalFlowStep.VERIFICATION:
        verifyApiCall(0, true);
        break;
      case CreditProposalFlowStep.UPDATE_IBAN:
      case CreditProposalFlowStep.BANK_READER:
        navigate(ROUTES_PATH.BANKREADER);
        break;
      case CreditProposalFlowStep.COUNTER_OFFER:
        navigate(ROUTES_PATH.COUNTER_OFFER);
        break;
      case CreditProposalFlowStep.PERSONAL_FINANCES:
        navigate(ROUTES_PATH.PERSONAL_FINANCES);
        break;
      default:
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
        break;
    }
  };
  const handleContinue = () => {
    AnalyticsService.continueShipping({
      continue_mode: optionSelected !== NotificationType.EMAIL && optionSelected !== NotificationType.SMS ? "SAMEDEVICE" : optionSelected,
      time_elapsed: AnalyticsHelper.getTimeElapse({ initTime: startTime, finishTime: dayjs() }),
      step_number: 4,
    })
    if (
      optionSelected === NotificationType.EMAIL ||
      optionSelected === NotificationType.SMS
    ) {
      operationMethod(optionSelected);
    } else {
      loadingRequest(true);
      continueNavigation();
    }
  };

  return (
    <>
      <Title>Elige dónde quieres que enviemos el enlace al cliente:</Title>
      <ShippingOptions>
        <ShippingButton
          onClick={() => setOptionSelected(NotificationType.EMAIL)}
        >
          <CheckboxContainer>
            <ButtonCheckbox
              type="radio"
              id="notification-send-email"
              checked={optionSelected === NotificationType.EMAIL}
              readOnly
            />
          </CheckboxContainer>
          <ButtonText>
            <TextMedium $fontSize={14} $color={"gray6"}>
              Email
            </TextMedium>
            <TextRegularEllipsis $fontSize={14} $color={"gray6"}>
              {customer?.email}
            </TextRegularEllipsis>
          </ButtonText>
        </ShippingButton>
        <ShippingButton onClick={() => setOptionSelected(NotificationType.SMS)}>
          <CheckboxContainer>
            <ButtonCheckbox
              type="radio"
              id="notification-send-sms"
              checked={optionSelected === NotificationType.SMS}
              readOnly
            />
          </CheckboxContainer>
          <ButtonText>
            <TextMedium $fontSize={14} $color={"gray6"}>
              Sms
            </TextMedium>
            <TextRegular $fontSize={14} $color={"gray6"}>
              {customer?.phones[0]}
            </TextRegular>
          </ButtonText>
        </ShippingButton>
        {showContinueBtn && (
          <ShippingButton
            onClick={() => setOptionSelected(NotificationType.CONTINUE)}
          >
            <CheckboxContainer>
              <ButtonCheckbox
                type="radio"
                id="notification-send-continue"
                checked={optionSelected === NotificationType.CONTINUE}
                readOnly
              />
            </CheckboxContainer>
            <ButtonText>
              <TextMedium $fontSize={14} $color={"gray6"}>
                Continuar en este dispositivo
              </TextMedium>
            </ButtonText>
          </ShippingButton>
        )}
      </ShippingOptions>
      <MainButton
        onClick={handleContinue}
        disabled={!optionSelected}
        id="notification-form-btn"
      >
        Continuar
      </MainButton>
    </>
  );
};
